const version = __APP_VERSION__;
const commit = __COMMIT_SHA__;

/**
 * Raw Vercel deploy environment, injected at build time from `VERCEL_ENV`:
 * - "production" → app.todowith.ai (main branch)
 * - "preview"    → dev.todowith.ai (dev branch)
 * - ""           → local `npm run dev`
 *
 * NOTE: `import.meta.env.PROD` is `true` for BOTH "production" and "preview"
 * (they are both `vite build`), so this is the only value that separates them.
 */
export const DEPLOY_ENV = __DEPLOY_ENV__;

/** True only on the real production deployment (app.todowith.ai). */
export const IS_PRODUCTION = DEPLOY_ENV === "production";

/** Short identifier for the non-production environment shown in the dev banner. */
export const ENV_LABEL = DEPLOY_ENV === "preview" ? "dev.todowith.ai" : "LOCAL";

export const APP_VERSION_DISPLAY =
  DEPLOY_ENV === "production"
    ? `v${version}`
    : DEPLOY_ENV === "preview"
      ? `v${version}-dev.${commit}`
      : `v${version}-local`;
